// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"206":"8a965256","587":"100db581","848":"2ce9748f"}[chunkId] + ".js";
};